<template>
    <div>
        <div class="footer">
            <div>{{title}}</div>
            <div>{{page}}</div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: '上海弈客信息技术有限公司'
            },
            page: {
                type: String,
                default: '00'
            },
        },
    }
</script>
<style scoped>
    .footer {
        display: flex;
        align-items: center;
        color: #808080;
        font-size: 12px;
        justify-content: space-between;
        padding: 0px 5%;
        width: 100%;
        box-sizing: border-box;
        position: absolute;
        bottom: 10px;
    }
</style>